const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-permissions",
    meta: {},
    name: "m-permissions",
    component: () => import("@/modules/mpermissions/RootView")
});

export default Routes;